import React, { Fragment } from 'react'
import { Text, View, StyleSheet } from '@react-pdf/renderer';
import NoData from './NoData';

const AdvanceTableData = ({data}) => {
    const styles = StyleSheet.create({
        Flightcontainer: {
            flexDirection: 'row',
            alignItems : 'center',
            fontStyle: 'bold',
            paddingBottom : '5px',
            paddingTop : '10px',
            paddingLeft : '15px',
            border : "1px solid #E4E4E4",
            borderRadius : '5px',
            width : '100%',
            marginTop: '5px',
        },
        one: {
            width : '15%',
            fontSize : "11px",
            color : "#333333"
        },
        two: {
            width : '20%',
            fontSize : "11px",
            color : "#333333"
        },
        three:{
            width : '20%',
            fontSize : "11px",
            color : "#333333"
        },
        four: {
            width : '25%',
            fontSize : "11px",
            color : "#333333"
        },
        five: {
            width : '20%',
            fontSize : "11px",
            color : "#333333"
        },
    });
    return (
        <Fragment>
            {
                data && data.length > 0 ?
                    data?.map((items, index) => (
                        <View style={styles.Flightcontainer}>
                            <Text  style={styles.one}>{items?.advance_number ? items?.advance_number : "-"}</Text>
                            <Text style={styles.two}>{items?.advance_date ? items?.advance_date : "-"}</Text>
                            <Text style={styles.three}>{items?.submitted_by ? items?.submitted_by : "-"}</Text>
                            <Text style={styles.four}>{items?.reference_no ? items?.reference_no : "-"}</Text>
                            <Text style={styles.five}>{items?.amount ? items?.amount : "-"}</Text>
                        </View>
                    )) : <NoData title='Advance Data' />

            }
        </Fragment>
    )
}

export default AdvanceTableData;